import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { Observable } from 'rxjs';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';

export class OneClickTimeWindowProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[0]),
      map(item => {
        return `${item.timeWindowDesc}`;
      }),
    );
  }
}
